import type { MarkerFeature } from "../../../../../utils/models/MarkerFeature";
import type { LineStringFeature } from "../../../../../utils/models/LineStringFeature";
import type { UndoCommand, CommandContext } from "../types";

/**
 * Command for inserting a marker at a point on an existing linestring,
 * splitting the linestring into two.
 */
export class InsertMarkerCommand implements UndoCommand {
  readonly type = 'INSERT_MARKER';
  readonly routeKey: string;

  private insertIndex: number;
  private marker: MarkerFeature;
  private originalLineStringIndex: number;
  private originalLineString: LineStringFeature;
  private newLineString1: LineStringFeature;
  private newLineString2: LineStringFeature;

  constructor(data: {
    routeKey: string;
    insertIndex: number;
    marker: MarkerFeature;
    originalLineStringIndex: number;
    originalLineString: LineStringFeature;
    newLineString1: LineStringFeature;
    newLineString2: LineStringFeature;
  }) {
    this.routeKey = data.routeKey;
    this.insertIndex = data.insertIndex;
    this.marker = JSON.parse(JSON.stringify(data.marker));
    this.originalLineStringIndex = data.originalLineStringIndex;
    this.originalLineString = JSON.parse(JSON.stringify(data.originalLineString));
    this.newLineString1 = JSON.parse(JSON.stringify(data.newLineString1));
    this.newLineString2 = JSON.parse(JSON.stringify(data.newLineString2));
  }

  undo(ctx: CommandContext): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    // Remove the inserted marker
    route.markers.splice(this.insertIndex, 1);

    // Remove the two split linestrings and restore the original
    route.lineStrings.splice(
      this.originalLineStringIndex, 2,
      JSON.parse(JSON.stringify(this.originalLineString))
    );

    route.updated_at = new Date();
  }

  redo(ctx: CommandContext): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    // Re-insert the marker
    route.markers.splice(this.insertIndex, 0, JSON.parse(JSON.stringify(this.marker)));

    // Replace the original linestring with the two split ones
    route.lineStrings.splice(
      this.originalLineStringIndex, 1,
      JSON.parse(JSON.stringify(this.newLineString1)),
      JSON.parse(JSON.stringify(this.newLineString2))
    );

    route.updated_at = new Date();
  }
}
